import React, { useState } from 'react';

//********************************Componentes Generales******************************************* */


///**********************Componentes PrimeReact******************************************** */
import { Dialog } from 'primereact/dialog';
//*****************************Consultas API*************************************************************** */

import Loader from '../../../../Components/Loader/Loader';
import { TabPanel, TabView } from 'primereact/tabview';

//****************************Componentes Especificos************************************* */
import ProductoTab from './Tabs/ProductoTab';

const ModalProductos = ({ dialogProducto, setDialogProducto, hideDialog, IdProducto, toast, refresh = () => { } }) => {

    const [loading, setLoading] = useState(false)
    const [activeIndex, setActiveIndex] = useState(0);
    const [NombreProducto, setNombreProducto] = useState('')


    return (
        <Dialog visible={dialogProducto} style={{ width: '60vw', height: '40vh' }} onHide={hideDialog} header={NombreProducto} closeOnEscape={false} >
            <Loader querySelector='#ModalProductos' loading={loading} />
            <TabView className='col-12 homeTabView' activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header='Producto'>
                    <ProductoTab IdProducto={IdProducto} toast={toast} hideDialog={hideDialog} refresh={refresh} setNombreProducto={setNombreProducto} />
                </TabPanel>
               
            </TabView>

        </Dialog>
    )
}

export default ModalProductos